import type { PublicSlotKey } from '#packages/apilib';
import type { WixCodeWorkspaceApi } from './api';

export const WixCodeWorkspaceApiKey: PublicSlotKey<WixCodeWorkspaceApi> = {
  name: 'WixCodeWorkspaceApi',
  public: true,
};
